<script setup lang="ts">
import { cloneDeep } from 'lodash'
import { VNode } from 'vue'

import { Coordinates } from '@collector/shared-ui-domain'
import { useIncidentGroupComponents } from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/composables/useIncidentGroupComponents'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'

import ExpectedGoalsDetailsModal from '../components/ExpectedGoals/ExpectedGoalsDetailsModal.vue'
import { GroupName, groups } from './consts'

interface Props {
  linkedIncident: ProbableLinkedIncident
}

const props = defineProps<Props>()

// emits
const emit = defineEmits(['close'])

// data
const localLinkedIncident = cloneDeep(props.linkedIncident)

// composables
const incidentGroupComponentsComposable = useIncidentGroupComponents(
  localLinkedIncident,
  groups,
)
const { updateIncident: _updateIncident } = incidentGroupComponentsComposable

// methods
function updateIncident(data: { coordinates: Coordinates | null }): void {
  _updateIncident({
    x_pos: data.coordinates?.x,
    y_pos: data.coordinates?.y,
  })

  emit('close')
}

function getGroupComponent(name: GroupName): VNode | null {
  return incidentGroupComponentsComposable.getGroupComponent(groups.get(name)!)
}
</script>

<template>
  <ExpectedGoalsDetailsModal
    :linkedIncident="localLinkedIncident"
    @save="updateIncident"
    @close="$emit('close')"
  >
    <template #coordinatesTabContent>
      <component :is="getGroupComponent(GroupName.Distance)" />
    </template>

    <template #detailsTabContent>
      <component :is="getGroupComponent(GroupName.TechniqueOfShot)" />
      <component :is="getGroupComponent(GroupName.TechniqueOfShotDetails)" />
      <component :is="getGroupComponent(GroupName.PressureOfDefenders)" />
      <component
        :is="getGroupComponent(GroupName.NumberOfDefendersOnTheLineOfShot)"
      />
      <component :is="getGroupComponent(GroupName.AdditionalAttributes)" />
    </template>
  </ExpectedGoalsDetailsModal>
</template>
